import React from "react";
import { FaFacebook, FaLinkedin, FaTwitter, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaInstagram } from "react-icons/fa";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-brand">
          <h2>Afrivision Consultants Ltd</h2>
          <p>Empowering businesses through strategy, innovation, and execution excellence.</p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#blog">Blog</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p><FaMapMarkerAlt /> Kayonza, Rwanda</p>
          <p><FaPhoneAlt /> +250 795 459 039</p>
          <p><FaEnvelope /> info@afrivisionconsultants.com</p>
          {/* <p><FaEnvelope /> info@afrivision.co.ke</p> */}
        </div>

        {/* Socials */}
        <div className="footer-socials">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://web.facebook.com/"><FaFacebook /></a>
            <a href="https://www.instagram.com/"><FaInstagram /></a>
            <a href="https://x.com/home"><FaTwitter /></a>
            <a href="https://x.com/home"><FaLinkedin /></a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Afrivision Consultants Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
